import { Injectable, signal } from '@angular/core';

/**
 * #FUNCIONALIDAD Avisa cuándo terminó el arranque de la app (la pantalla de carga empieza a ocultarse).
 * Las pantallas con animación de entrada (p. ej. el login) la esperan: si arrancaran antes, la animación
 * correría oculta detrás de la pantalla de carga y el usuario no la vería.
 */
@Injectable({ providedIn: 'root' })
export class AppBootService {
  private readonly _ready = signal(false);
  readonly ready = this._ready.asReadonly();

  markReady(): void {
    this._ready.set(true);
  }
}
